import { render, staticRenderFns } from "./modal-result-people.vue?vue&type=template&id=24d8772a&scoped=true"
import script from "./modal-result-people.vue?vue&type=script&lang=js"
export * from "./modal-result-people.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8772a",
  null
  
)

export default component.exports